import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './index.scss'
const InviteAuth = (props) => {
  let { inviterCondition, invitep, getmoney } = props
  let history = useHistory()
  //达标按钮的类型
  let [btnType, setBtnType] = useState();
  //查找达标类型
  function getType(arr) {
    if (arr) {
      for (let i = 0, k = arr.length; i < k; i++) {
        //更改！
        if (!arr[i].ok) {
          setBtnType(arr[i].type)
          return
        }
      }
    }
  }
  //去认证
  const handleGoAuth = () => {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      window.deAuthentication.onDeAuthentication();
    } else if (isIOS) {
      window.WebViewJavascriptBridge.callHandler('gotoAuthentication');
    }
  }
  //去出车
  const handleGoCar = () => {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      window.goingToDrive.OnGoingToDrive()
    } else if (isIOS) {
      window.WebViewJavascriptBridge.callHandler('gotoWork');
    }
  }
  //退出
  const handleGoBackHeader = () => {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      // window.handleGoBack();//这里的.android是安卓那边定义的类,可以随便定义,但这里必须要跟安卓那边统一
      window.handleGoBack.pop()
    } else if (isIOS) {
      // window.webkit.messageHandlers.handleGoBack.postMessage({});
      window.WebViewJavascriptBridge.callHandler('handleGoBack');
    }
  }
  useEffect(() => {
    getType(inviterCondition);
  })
  return (
    <div className="invite-auth__box">
      <div className="invite-auth__con">
        <h2>邀请条件未达标</h2>
        <h3>邀请人满足以下条件方可去邀请</h3>

        {
          inviterCondition.map((item, index) => (
            <p key={index}>
              {
                item.ok ? <em style={{ borderColor: '#888', color: '#888' }}>已通过</em> :
                  <em style={{ borderColor: React.colorConfig.mainColor, color: React.colorConfig.mainColor }}>未通过</em>
              }
               {item.desc}
            </p>
          ))
        }

        <div className="btn_box">
          {/* <span onClick={() => { history.push(`/inviteinfo/${invitep}/${getmoney}`) }}>以后再说</span> */}
          <span onClick={handleGoBackHeader}>以后再说</span>
          {
            btnType === 1 ? <span style={{ color: React.colorConfig.mainColor }} onClick={handleGoAuth}>先去达标</span> :
              (btnType === 2 ? <span style={{ color: React.colorConfig.mainColor }} onClick={handleGoCar}>先去达标</span> : '')
          }

        </div>
      </div>
    </div>
  )
}
export default InviteAuth
